module.exports = __webpack_public_path__ + "img/theme-candena_logo.c8c3655e.png";